<template>
<div :class="`plan ${selected ? 'selected' : ''}`">
  <header>
    <div class="top">
      <h2>{{ plan.title }}</h2>
      <template v-if="plan.priceMonth === 0">
      </template>
      <template v-else>
        <div class="price" v-if="currencyIndex >= 0">
          <template v-if="interval === 'yearly'">
            <div class="discount" v-if="discount">
              {{ discount }}% {{ $t('settings.plan.discount') }}
            </div>
            <em>{{ $t('settings.plan.yearly') }} {{ plan.currencies[currencyIndex].currency.symbolAfter ? '' : plan.currencies[currencyIndex].currency.symbol }}{{ plan.currencies[currencyIndex].priceYear }} {{ plan.currencies[currencyIndex].currency.symbolAfter ? plan.currencies[currencyIndex].currency.symbol : '' }}</em>
            <div>
              {{ plan.currencies[currencyIndex].currency.symbolAfter ? '' : plan.currencies[currencyIndex].currency.symbol }}{{ Math.round(plan.currencies[currencyIndex].priceYear / 12) }} {{ plan.currencies[currencyIndex].currency.symbolAfter ? plan.currencies[currencyIndex].currency.symbol : '' }}
              <span>/{{ $t('settings.plan.mo') }}</span>
            </div>
          </template>
          <template v-else-if="interval === 'monthly'">
            <em>{{ $t('settings.plan.yearly') }} {{ plan.currencies[currencyIndex].currency.symbolAfter ? '' : plan.currencies[currencyIndex].currency.symbol }}{{ plan.currencies[currencyIndex].priceMonth * 12 }} {{ plan.currencies[currencyIndex].currency.symbolAfter ? plan.currencies[currencyIndex].currency.symbol : '' }}</em>
            <div>
              {{ plan.currencies[currencyIndex].currency.symbolAfter ? '' : plan.currencies[currencyIndex].currency.symbol }}{{ plan.currencies[currencyIndex].priceMonth }} {{ plan.currencies[currencyIndex].currency.symbolAfter ? plan.currencies[currencyIndex].currency.symbol : '' }}
              <span>/{{ $t('settings.plan.mo') }}</span>
            </div>
          </template>
        </div>
      </template>
    </div>
    <div class="description">{{ plan.text }}</div>
  </header>
  <section>
    <template v-for="(category, index) in plan.categories">
      <div :key="index" v-if="category.text">
        <h3>{{ category.pricing_category.name }}</h3>
        <p v-html="category.text"></p>
      </div>
    </template>
  </section>
  <footer>
    <template v-if="plan.checkoutParams">
      <Button :class="`${selected ? 'very-blue-border' : 'very-blue'} rounded`" @click="action">
        {{ selected ? $t('settings.plan.manage_subscription') : plan.checkoutParams.url ? $t('settings.plan.buttons.contact_sales') : lone ? $t('settings.plan.to_payment') : $t('settings.plan.select_plan') }}
      </Button>
    </template>
    <template v-else>
      <Button class="very-no-border rounded strong">{{ selected ? $t('settings.plan.selected_plan') : '' }}</Button>
    </template>
  </footer>
</div>
</template>

<script>
export default {
  props: {
    plan: {
      type: Object,
      required: true,
    },
    successPath: {
      type: String,
    },
    cancelPath: {
      type: String,
    },
    interval: {
      type: String,
      validator: value => ['monthly', 'yearly'].indexOf(value) !== -1,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    currency: {
      type: String,
      validator: value => ['sek', 'eur', 'usd'].indexOf(value) !== -1,
    },
    lone: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currencyIndex() {
      const { currency } = this;
      if (!this.plan.currencies) {
        return -1;
      }

      return this.plan.currencies.findIndex((c) => {
        const curr = c.currency.name ? c.currency.name.toLowerCase() : '';
        switch (currency) {
          case 'sek':
            if (curr.toLowerCase() === 'sek') {
              return true;
            }
            break;
          case 'eur':
            if (curr === '€' || curr === 'eur') {
              return true;
            }
            break;
          /*
          case 'usd':
            if (curr === '$' || curr === 'usd') {
              return true;
            }
            break;
          */
          default:
            break;
        }
        return false;
      });
    },
  },
  methods: {
    getIconName(icon) {
      switch (icon) {
        case 'cross':
          return 'mdi-close includes includes--cross';
        case 'checkbox':
          return 'mdi-check includes includes--checkbox';
        case 'plus':
          return 'mdi-plus includes includes--plus';
        default:
          return '';
      }
    },
    async action() {
      if (this.selected) {
        const success = await this.$store.dispatch('Plan/getManagePlanLink');
        if (!success) {
          swal({
            title: 'An error occured',
            text:
              'For some reason we could not open the plan management page right now',
            icon: 'error',
          });
        }

        // TODO:
        // Do something with the link

        return;
      }

      if (this.plan.checkoutParams.url) {
        window.open(this.plan.checkoutParams.url);
        return;
      }

      const {
        interval: billingInterval,
        currency,
        plan: {
          // title: plan,
          checkoutParams: {
            trial,
            plan,
          },
        },
        successPath: success_path,
        cancelPath: cancel_path,
      } = this;

      const success = await this.$store.dispatch('Plan/getCheckoutLink', {
        billingInterval: this.shoppingSettings.provider === 'shopline' ? 'monthly' : billingInterval,
        currency,
        trial,
        plan: plan.toLowerCase(),
        success_path,
        cancel_path,
      });

      if (!success) {
        swal({
          title: 'An error occured',
          text:
            'For some reason we could not get that plan right now',
          icon: 'error',
        });
      }
    },
  },
  data() {
    return {
      discount: 0,
    };
  },
  mounted() {
    const { priceMonth = 0, priceYear = 0 } = this.plan.currencies[0] || {};
    this.discount = Math.round(((priceMonth - (priceYear / 12)) / priceMonth) * 100);
  },
};
</script>

<style lang="scss" scoped>
.plan {
  margin: 0 auto;
  display: flex;
  background: #FFFFFF;
  border: 2px solid rgba(0,0,0,0.04);
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.04);
  border-radius: 32px;
  flex-direction: column;
  padding: 1.5rem;
  width: 100%;
  position: relative;

  header {
    display: flex;
    flex-direction: column;

    .top {
      flex: 1.4;
    }

    h2 {
      font-size: 1.5rem;
      line-height: 2rem;
      text-align: center;
    }

    .description {
      color: #767676;
      flex: 1;
      margin: 1rem 0;
      font-size: 0.9rem;
      text-align: center;
    }

    .discount {
      background-color: #06B25B;
      font-size: .9rem;
      line-height: 1rem;
      position: absolute;
      top: 0;
      left: 50%;
      color: white;
      transform: translateX(-50%) translateY(-50%);
      border-radius: 16px;
      font-weight: 700;
      padding: .4rem .75rem;
      text-transform: uppercase;
      text-align: center;
    }

    .price {
      flex-direction: column;
      color: #323232;
      text-align: center;
      font-size: 1.5rem;
      line-height: 1.5rem;
      margin: auto 0;

      & > div {
        justify-content: center;
        align-items: center;
        display: flex;

        span {
          font-size: 1rem;
          line-height: 1rem;
          color: #767676;
          margin-left: .25rem;
        }
      }

      em {
        font-size: .8rem;
        color: gray;
        font-style: normal;
        font-weight: 500;
      }
    }
  }

  section {
    h3 {
      font-size: .7rem;
      color: #000000;
      letter-spacing: 1.71px;
      line-height: .8rem;
      font-weight: 400;
      text-transform: uppercase;
    }
    p {
      display: flex;
      font-size: .8rem;
      line-height: 1.2rem;
      margin: .25rem 0 1rem;

      &.includes {
        padding-left: 1.5rem;
        &:before {
          line-height: 1.5rem;
          font-size: 1.25rem;
        }
      }
    }
  }
  footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: auto;
    padding-top: 1rem;
  }

  .includes {
    font-size: 1.3rem;
    margin-right: .5rem;
    &.includes--cross {
      color: red;
    }

    &.includes--checkbox {
      color: #00CE69;
    }

    &.includes--plus {
      color: #0060FF;
    }
  }

  &.selected {
    border: 2px solid #35ACDC;
  }
}
</style>
<style lang="scss">
.plan {
  .sficon-checkbox-thin {
    color: #00CE69;
    font-size: 18px;
  }

  .sficon-close-x {
    color: #DD4036;
    font-size: 18px;
  }
}
</style>
